<mat-horizontal-stepper [linear]="true" #stepper>
   <mat-step estimationForm [stepControl]="estimationForm">
    <form [formGroup]="estimationForm " class="p-6 bg-white rounded-lg shadow-md">
     <ng-template matStepLabel>{{
        projectId ? ("UPDATE_PROJECT" | translate) : ("ADD_PROJECT" | translate)
      }}</ng-template>
  <div class="grid grid-cols-12 gap-6">
   <div class="col-span-6">
          <mat-label>Company Name</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="company_name" readonly />
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>Company Code</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="company_code" readonly />
          </mat-form-field>
        </div>
       
         <div class="col-span-6">
          <mat-label>{{ "PROJECT_NAME" | translate }}</mat-label>

          <mat-form-field appearance="outline" class="w-full">
             <input matInput formControlName="project_name" *ngIf="!proShow" readonly />
            <mat-select *ngIf="proShow"
              formControlName="project_id"
              (selectionChange)="onProjectChange($event.value)"
            >
              <mat-option value="">{{
                "SELECT_Project" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let project of projectList"
                [value]="project.id"
                >{{ project.project_name }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="estimationForm.get('project_name')?.hasError('required')">
              {{ "PROJECT_NAME_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>Project ID</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="project_id" readonly="" />
          </mat-form-field>
        </div>
    <div class="col-span-6">
      <mat-label>Estimation Lead</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="estimation_lead" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Start Date</mat-label>

      <mat-form-field appearance="outline">
        <input
          matInput
          [matDatepicker]="start"
          formControlName="estimation_start_date"
        />
        <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
        <mat-datepicker #start></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label> End Date</mat-label>

      <mat-form-field appearance="outline">
        <input
          matInput
          [matDatepicker]="end"
          formControlName="estimation_end_date"
        />
        <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
        <mat-datepicker #end></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Methodology</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="estimation_methodology" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Cost Categories</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="cost_categories" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Contingency %</mat-label>

      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="contingency_percentage" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Currency Usede</mat-label>

      <mat-form-field appearance="outline">
        <input matInput formControlName="currency_used" />
      </mat-form-field>
    </div>
    <div class="col-span-6">
      <mat-label>Estimation Doc Ref</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="estimation_document_ref" />
      </mat-form-field>
    </div>

    <!-- Domain Dropdown -->
    <div class="col-span-12">
      <mat-label>Domain</mat-label>

      <mat-form-field appearance="outline" class="col-span-2">
        <mat-select
          formControlName="domain"
          (selectionChange)="onDomainChange($event.value)"
        >
          <mat-option *ngFor="let domain of domainOptions" [value]="domain">
            {{ domain }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Dynamic Fields -->

    <ng-container *ngFor="let field of domainFields[selectedDomain]">
      <div class="col-span-4">
        <mat-label>{{ field.label }}</mat-label>

        <mat-form-field
          appearance="outline"
          *ngIf="estimationForm .get(field.key)"
        >
          <input matInput [type]="field.type" [formControlName]="field.key" />
        </mat-form-field>
      </div>
    </ng-container>

 
  </div>
     <!-- Submit Button -->
    <div class="col-span-2 flex justify-end mt-4">
      <button
        mat-raised-button
        color="primary"
        matStepperNext
        [disabled]="estimationForm .invalid"
      >
        Location
      </button>
    </div>
</form>

   </mat-step>
     <mat-step [stepControl]="locationForm">
    <form [formGroup]="locationForm" class="w-full">
      <ng-template matStepLabel>{{ "LOCATION" | translate }}</ng-template>

      <div formArrayName="location">
        <div
          *ngFor="let branch of location.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "COUNTRY" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <mat-select
                  formControlName="country"
                  (selectionChange)="onCountryBChange(i)"
                  required
                >
                  <mat-option value="">{{
                    "SELECT_COUNTRY" | translate
                  }}</mat-option>
                  <mat-option value="India">India</mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('country')?.hasError('required')">
                  {{ "COUNTRY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "STATE" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <mat-select
                  formControlName="state"
                  (selectionChange)="onStateBChange(i)"
                  required
                >
                  <mat-option value="">{{
                    "SELECT_STATE" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let state of availableStates[i]"
                    [value]="state"
                  >
                    {{ state }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('state')?.hasError('required')">
                  {{ "STATE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "CITY" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <mat-select formControlName="city" required>
                  <mat-option value="">{{
                    "SELECT_CITY" | translate
                  }}</mat-option>
                  <mat-option
                    *ngFor="let city of availableCities[i]"
                    [value]="city"
                  >
                    {{ city }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="branch.get('city')?.hasError('required')">
                  {{ "CITY_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>{{ "POSTAL_CODE" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Pincode"
                  formControlName="pincode"
                />
                <mat-error *ngIf="branch.get('pincode')?.hasError('required')">
                  {{ "PINCODE_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label> {{ "line1" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_1" />
                <mat-error
                  *ngIf="branch.get('address_line_1')?.hasError('required')"
                >
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label> {{ "line2" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="address_line_2" />
                <mat-error
                  *ngIf="branch.get('address_line_2')?.hasError('required')"
                >
                  {{ "employee.address" | translate }}
                  {{ "REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="flex flex-row gap-4">
            <button
              mat-stroked-button
              type="button"
              (click)="openPicker(i, branch)"
            >
              {{ "locateOnMap" | translate }}
            </button>
          </div>

          <div class="flex flex-row gap-4">
            <div class="half-width">
              <mat-label>{{ "LAT" | translate }}</mat-label>

              <mat-form-field appearance="outline">
                <input
                  matInput
                  placeholder="Latitude"
                  formControlName="lat"
                  readonly
                />
                <mat-error *ngIf="branch.get('lat')?.hasError('required')">
                  {{ "LAT_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "LONG" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="long" readonly />
                <mat-error *ngIf="branch.get('long')?.hasError('required')">
                  {{ "LONG_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="false" class="form-actions mt-4 flex gap-4">
            <button
              *ngIf="location.length > 1"
              mat-raised-button
              color="warn"
              type="button"
              (click)="removeBranch(i)"
            >
              {{ "REMOVE" | translate }}
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="addBranch()"
            >
              {{ "ADD_BRANCH" | translate }}
            </button>
          </div>

          <mat-divider class="my-4"></mat-divider>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6">
        <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!locationForm.valid"
        >
          {{ "NEXT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step clientForm [stepControl]="clientForm">
    <form [formGroup]="clientForm" class="w-full">
      <ng-template matStepLabel>{{ "CLIENT" | translate }}</ng-template>

      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-6">
          <mat-label>{{ "CLIENT_NAME" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="client_name" />
            <mat-error
              *ngIf="clientForm.get('client_name')?.hasError('required')"
            >
              {{ "CLIENT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "CLIENT_PERSON" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_person" />
            <mat-error
              *ngIf="clientForm.get('contact_person')?.hasError('required')"
            >
              {{ "CLIENT_PERSON_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "CLIENT_NUMBER" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="contact_number" />
            <mat-error
              *ngIf="clientForm.get('contact_number')?.hasError('required')"
            >
              {{ "CLIENT_NUMBER_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "Khasra_no" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="khasra_no" />
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "Area" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="area" />
          </mat-form-field>
        </div>
        <div class="col-span-6">
          <mat-label>{{ "STATE" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="state"
              (selectionChange)="getdistricts()"
            >
              <mat-option value="">{{ "SELECT_STATE" | translate }}</mat-option>
              <mat-option *ngFor="let state of allState" [value]="state">{{
                state
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="clientForm.get('state')?.hasError('required')">
              {{ "STATE_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "DISTRICT" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="district"
              (selectionChange)="getsubdistricts()"
            >
              <mat-option value="">{{
                "SELECT_DISTRICT" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let district of allDistricts"
                [value]="district"
                >{{ district }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="clientForm.get('district')?.hasError('required')">
              {{ "DISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "SUBDISTRICT" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select
              formControlName="subDistrict"
              (selectionChange)="getvillages()"
            >
              <mat-option value="">{{
                "SELECT_SUBDISTRICT" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let subdistrict of allSubDistricts"
                [value]="subdistrict"
                >{{ subdistrict }}</mat-option
              >
            </mat-select>
            <mat-error
              *ngIf="clientForm.get('subDistrict')?.hasError('required')"
            >
              {{ "SUBDISTRICT_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-span-6">
          <mat-label>{{ "VILLAGES" | translate }}</mat-label>
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="villages">
              <mat-option value="">{{
                "SELECT_VILLAGE" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let village of allVillage"
                [value]="village"
                >{{ village }}</mat-option
              >
            </mat-select>
            <mat-error *ngIf="clientForm.get('villages')?.hasError('required')">
              {{ "VILLAGES_REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="w-full flex justify-end mt-6">
        <button mat-button matStepperPrevious>{{ "BACK" | translate }}</button>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="w-60"
          (click)="onSubmit()"
        >
          {{
            projectId
              ? ("UPDATE_PROJECT" | translate)
              : ("SAVE_PROJECT" | translate)
          }}
        </button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>


